export default {"src":"/_next/static/media/deco_checkout_visa.49268e19.svg","height":34,"width":55,"blurWidth":0,"blurHeight":0};